module.exports = __webpack_public_path__ + "media/images/gallery/dn_tab_on-1cfdbcea920c9d85ac8a3fe9feb38d52.jpg";